<template>
  <div id="tab">
    <div :style="{'background':submeunIndex?'#fff':'transparent'}" class="tabBox">
        <ul class="tab1" :style="{'color':submeunIndex?'#1C66F3':'#fff'}">
            <li @click="jumphref('/')">
                <img src="@/assets/tab/logo.png" alt=""  class="logo" v-show="!submeunIndex">
                <img src="@/assets/tab/chunse.png" alt=""  class="logo" v-show="submeunIndex">
            </li>
            <li class="list2">
                <el-menu  :default-active="defaultactive" class="el-menu-demo" mode="horizontal"  @select="handleSelect" :text-color="submeunIndex?'#1C66F3':'#fff'"  :active-text-color="submeunIndex?'#1C66F3':'#fff'">
                    <el-menu-item index="/" :class="['elmenuitem','elmenuitem1',submeunIndex?'elmenuitem2':'']"><span @mouseover="handleOver()" class="productspan">产品服务</span><i class="el-submenu__icon-arrow el-icon-arrow-down"></i></el-menu-item>
                    <el-menu-item index="/course" class="elmenuitem">课程</el-menu-item>
                    <el-menu-item index="/school" class="elmenuitem">学堂</el-menu-item>
                    <el-menu-item index="/price" class="elmenuitem">价格</el-menu-item>
                    <el-menu-item index="/ecology" class="elmenuitem">生态</el-menu-item>
                    <el-menu-item index="/case" class="elmenuitem">案例</el-menu-item>
                    <el-submenu index="3" :class="['elmenuitem',submeunIndex?'elmenuitem3':'']">
                        <template slot="title">解决方案</template>
                        <el-menu-item index="/solution" class="my-item"><img src="@/assets/tab/icon1.png"/>时尚行业解决方案</el-menu-item>
                        <el-menu-item index="/bIndustry" class="my-item"><img src="@/assets/tab/icon2.png"/>美丽行业解决方案</el-menu-item>
                        <el-menu-item index="/pcEducation" class="my-item"><img src="@/assets/tab/icon3.png"/>亲子行业解决方案</el-menu-item>
                    </el-submenu>
                    <el-submenu index="4" :class="['elmenuitem',submeunIndex?'elmenuitem3':'']">
                        <template slot="title">关于我们</template>
                        <el-menu-item index="/about" class="my-item"><img src="@/assets/tab/icon4.png"/>关于我们</el-menu-item>
                        <el-menu-item index="/service" class="my-item"><img src="@/assets/tab/icon5.png"/>服务答疑</el-menu-item>
                    </el-submenu>
                    <el-menu-item index="9" :class="submeunIndex?'shiyong1':'shiyong2'"><span>免费试用</span></el-menu-item>
                </el-menu>
            </li>
            <li class="submeun" v-show="submeunIndex" @mouseleave="handleOver()">
            <!-- <li class="submeun">    -->
                <ul class="submeunUl">
                    <li class="left">
                        <p class="p1">使用场景</p>
                        <div v-for="(item,index) in pclist" :key="index" class="pcBox" @click="jumpPc(item.router)">
                            <div><img :src="url+item.image" alt=""></div>
                            <div>
                                <p class="p2">{{item.title}}</p>
                                <p class="p3">{{item.subtitle}}</p>
                            </div>
                        </div>
                        <div class="buttonBox">
                            <button class="button1" @click="submit(false)">免费试用</button>
                            <button class="button2" @click="submit(true)">立即咨询</button>
                        </div>
                    </li>
                    <li class="right">
                        <p class="p1">产品功能</p>
                        <ul>
                            <li v-for="(item,index) in funlist" :key="index">
                                <p @click="jumphref(item.router)">{{item.title}}</p>
                            </li> 
                        </ul>
                        <p class="p2">亿宝易SCRM·帮助品牌商家搭建O2O互联·引流获客·运营维护·成交管理·管理客户于一体的管理平台</p>
                    </li>
                </ul>
            </li>
        </ul>
    </div>

    <ul class="header_ul">
          <li class="header_ul_left"><img src="@/assets/tab/logo.png" @click="jumphref('/')"></li>
          <li class="header_ul_right2">
            <img src="@/assets/tab/more.png" alt="" @click="change()">
            <el-menu v-show="show"  :default-active="defaultactive" class="el-menu-demo1" mode="vertical" @select="handleSelect" background-color="#333" :text-color="submeunIndex?'#1C66F3':'#fff'" :active-text-color="submeunIndex?'#1C66F3':'#fff'">
                
                <el-submenu index="2">
                    <template slot="title">产品服务</template>
                    <el-menu-item index="/livingCode">亿宝易群活码</el-menu-item>
                    <el-menu-item index="/SCRM">亿宝易scrm</el-menu-item>
                    <el-menu-item index="/shopping">亿宝易私域商城</el-menu-item>
                    <el-menu-item index="/o2o">亿宝易O2O模式</el-menu-item>
                </el-submenu>
                <el-menu-item index="/course">课程</el-menu-item>
                <el-menu-item index="/school">学堂</el-menu-item>
                <el-menu-item index="/price">价格</el-menu-item>
                <el-menu-item index="/ecology">生态</el-menu-item>
                <el-menu-item index="/case">案例</el-menu-item>
                <el-submenu index="3">
                    <template slot="title">解决方案</template>
                    <el-menu-item index="/solution">时尚行业解决方案</el-menu-item>
                    <el-menu-item index="/bIndustry">美丽行业解决方案</el-menu-item>
                    <el-menu-item index="/pcEducation">亲子行业解决方案</el-menu-item>
                </el-submenu>
                <el-submenu index="4">
                    <template slot="title">关于我们</template>
                        <el-menu-item index="/about">关于我们</el-menu-item>
                    <el-menu-item index="/service">服务答疑</el-menu-item>
                </el-submenu>
                <el-menu-item index="9">免费试用</el-menu-item>
            </el-menu>
          </li>
        </ul>
        <mydialog v-if="showtc2" @tcstatus="tcstatus" :dialogVisible1="tcshow"></mydialog>
  </div>
</template>

<script>
import mydialog from '@/components/dialog/dialog.vue'
import { product,productleft } from '@/api/api'
var that
export default {
    components: {
        mydialog
    },
    data(){
        return{
            url:window.url,
            showtc2:false,
            tcshow:true,
            show:false,
            submeunIndex:false,
            defaultactive :"/",
            pclist:[

            ],
            funlist:[

            ]
        }
    },
    mounted(){
        that = this
        product().then((response) => {
            this.funlist = response.data.data
        })
        productleft().then((response) => {
            this.pclist = response.data.data
        })
        that.defaultactive =  this.$route.path
    },
    methods:{
        jumphref(e){
            this.$router.push(e)
        },
        handleOver(){
            this.submeunIndex = !this.submeunIndex
        },
        handleSelect(e){
            if(e==2){
                this.submeunIndex = !this.submeunIndex
                return false;
            }
            if(e==9){
                this.showtc2 = true
                this.show = false
                return false;
            }
            if(e != this.$route.path) {
                this.$router.push(e)
            }
        },
        tcstatus(e){
            this.showtc2 = e
        },
        submit(e){
            this.showtc2 = true
            this.tcshow = e
        },
        jumpPc(e){
            if(e != this.$route.path) {
                this.$router.push(e)
            }
        },
        change(){
            this.show = !this.show
        },
        tcstatus(e){
            this.showtc2 = e
        },
    }
}
</script>

<style lang="less">
    .v-modal{
        display: none!important;
    }
    .el-menu-item *{
        vertical-align: top!important;;
    }
    @media (min-width:750px) {
        #tab{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            z-index: 999;
            .tab1{
                width: 1400px;
                margin:0 auto;
                display: flex;
                justify-content: space-between;
                padding-top: 10px;
                align-content: center;
                position: relative;
                .list2{
                    width: 1150px;
                    display: flex;
                    justify-content: flex-end;
                }
                .logo{
                    width: 200px;
                    cursor: pointer;
                }
                .el-menu{
                    background-color: transparent;
                }
                .el-menu-item:not(.is-disabled):hover,.el-submenu__title:hover,.el-menu--horizontal:hover{
                    background-color: transparent!important;
                }
                .el-menu--horizontal>.el-menu-item:not(.is-disabled):focus{
                    background-color: transparent!important;
                }
                .el-menu,.el-menu--horizontal{
                    border-bottom: none;
                }
                .el-submenu__title i{
                    color: #fff;
                }
                .el-menu--horizontal>.el-submenu.is-active .el-submenu__title{
                    border-bottom: none!important;
                }
                .is-active{
                    border-bottom: none;
                    font-size: 22px;
                    font-weight: bold;
                }
                .el-menu-item,.el-submenu__title{
                    font-size: 20px;
                }
                .el-submenu__title *{
                    vertical-align: baseline;
                }
                .elmenuitem{
                    // width: 125px;
                    text-align: center;
                }
                .elmenuitem1 .el-submenu__icon-arrow{
                    right: 0px;
                    top: 60%;
                    color: #fff;
                    
                }
                .elmenuitem1{
                    margin-right: 16px;
                }
                .elmenuitem2 .el-submenu__icon-arrow{
                    transform: rotateZ(180deg);
                    color: #1B59E3!important;
                }
                .elmenuitem3 .el-submenu__icon-arrow{
                    color: #1B59E3!important;
                }

                .shiyong1{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    span{
                        background: #1B59E3;
                        border-radius: 40px;
                        color: #fff;
                        font-size: 16px;
                        width: 100px;
                        height: 30px;
                        display: flex;
                        text-align: center;
                        justify-content: center;
                        align-items: center;
                    }
                }
                .shiyong2{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    span{
                        background: #fff;
                        border-radius: 40px;
                        color: #1B59E3;
                        font-size: 16px;
                        width: 100px;
                        height: 30px;
                        display: flex;
                        text-align: center;
                        justify-content: center;
                        align-items: center;
                    }
                }
                .submeun{
                    position: absolute;
                    top: 100%;
                    left: 0;
                    width: 100%;
                    background-color: #fff;
                    border-radius: 0 0 16px 16px;
                    .submeunUl{
                        display: flex;
                        justify-content: space-between;
                        padding: 32px 27px;
                        .p1{
                            font-size: 24px;
                            font-weight: normal;
                            color: #000000;
                            position: relative;
                            margin-bottom: 36px;
                        }
                        .p1::after{
                            content:"";
                            display: block;
                            width: 36px;
                            height: 4px;
                            background: #1296DB;
                            position: absolute;
                            left: 0;
                            bottom: -14px;
                        }
                        .left{
                            width: 450px;
                            border-right: 1px solid #E9E6E6;
                            img{
                                width: 48px;
                                margin-right: 19px;
                            }
                            .pcBox{
                                display: flex;
                                align-items: center;
                                margin-bottom: 30px;
                                cursor: pointer;
                                .p2{
                                    font-size: 20px;
                                    font-weight: normal;
                                    color: #000000;
                                    margin-bottom: 2px;
                                }
                                .p3{
                                    font-size: 16px;
                                    font-weight: normal;
                                    color: #000000;
                                }
                            }
                            .buttonBox{
                                display: flex;
                                justify-content: center;
                                button:nth-child(1){
                                    width: 121px;
                                    height: 37px;
                                    background: #558AFF;
                                    border-radius: 32px 32px 32px 32px;
                                    font-size: 18px;
                                    font-weight: normal;
                                    color: #F2F2F2;
                                    margin-right: 43px;
                                    cursor: pointer;
                                }
                                button:nth-child(2){
                                    width: 121px;
                                    height: 37px;
                                    background: #FFFFFF;
                                    border-radius: 32px 32px 32px 32px;
                                    opacity: 1;
                                    border: 1px solid #558AFF;
                                    font-size: 18px;
                                    font-weight: normal;
                                    color: #558AFF;
                                    cursor: pointer;
                                }
                            }
                        }
                        .right{
                            width: 840px;
                            margin-left: 20px;
                            ul{
                                display: flex;
                                flex-wrap: wrap;
                                li{
                                    width: 120px;
                                    margin-right: 20px;
                                    p{
                                        margin-bottom: 26px;
                                        font-size: 16px;
                                        font-weight: normal;
                                        color: #333333;
                                        cursor: pointer;
                                    }
                                }
                                li:nth-child(-n+6){
                                    p:nth-child(1){
                                        font-size: 22px;
                                        font-weight: normal;
                                        color: #1296DB;
                                        position: relative;
                                    }
                                    p:nth-child(1)::after{
                                        content:"";
                                        display: block;
                                        width: 2px;
                                        height: 21px;
                                        background: #D2D2D2;
                                        border-radius: 6px 6px 6px 6px;
                                        position: absolute;
                                        top: 10%;
                                        right: 5%;
                                    }
                                }
                                li:nth-child(6n){
                                    margin-right: 0;
                                    p:nth-child(1)::after{
                                        content:"";
                                        background: transparent;
                                    }
                                }
                            }
                            .p2{
                                font-size: 14px;
                                font-weight: normal;
                                color: #444444;
                                text-align: center;
                            }
                        }
                    }
                }
            }
        }
        .my-item{
            color: #909399!important;
            img{
                width: 30px;
                margin-right: 20px;
            }
        }
        
        .header_ul{
            display: none;
        }
    }
    @media screen and (max-width:750px) {
        #tab{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            z-index: 999;
            .tabBox{
                display: none;
            }
            height: 2.19rem;
            min-width:100%;
            width: 100%;
            padding:0.88rem 1.25rem;
            .header_ul{
                display: flex;
                justify-content: space-between;
                .header_ul_left{
                    img{
                        width: 5.56rem;
                        cursor: pointer;
                    }
                }
                .header_ul_right2{
                    display: block;
                    position: relative;
                    .el-menu-demo1{
                        width: 20rem;
                        text-align: right;
                        position: absolute;
                        top: 2rem;
                        right: 0rem;
                        box-shadow: 0rem 0rem 1rem 0rem rgba(0,0,0,0.2000);
                        font-size: 0.63rem;
                        padding-right: 0.44rem;
                        padding-top: 1.06rem;
                        z-index: 1999;
                        li{
                            color: #888888;
                        }
                        .on{
                            color: #333333;
                        }
                    }
                }
            }
        }
    }
</style>